import type { CookieOptions } from "@supabase/ssr";

export function getSupabaseCookieOptions(options: CookieOptions = {}): CookieOptions {
  return {
    ...options,
    path: "/",
    sameSite: "lax",
    secure: process.env.NODE_ENV === "production"
  };
}
